import React from "react";
import { useTranslation } from "react-i18next";
import { CheckboxIcon, ShieldExclamationIcon } from "@aureskonnect/react-ui";
import { ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import { setIsModesModalDisassociate } from "../../../store/project";

import { store as userStore } from "@components/VerticalLayout/store";
import { setKey } from "../store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ModalPublishType = {
    rowData: any;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export default function CardFooterModalDissociateProject({
    rowData,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: ModalPublishType) {
    const { t } = useTranslation();
    const { userID, franchiseID, operatorID } = useSnapshot(userStore);
    const uuidUser = localStorage.getItem("uuidUser");
    const [isClicked, setIsClicked] = React.useState(false);
    async function handleSaveButtonOnClickEvent() {
        setIsClicked(true);
        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/projects/dissociate`;
        let shopIds: any = [];

        let shopPublic = [];
        let projectIds: any = {};
        const validRows = rowData.filter(
            (row: any) => row.shopId !== 0 && row.key_application === undefined
        );

        for (const row of validRows) {
            const { shopId, Status, id_project } = row;

            if (Status !== "Publié") {
                shopIds.push(shopId);
                const shopName = row[t("Designation")];
                if (projectIds[id_project]) {
                    const currentNames = projectIds[id_project].shopName.split(
                        ", "
                    );
                    if (!currentNames.includes(shopName)) {
                        currentNames.push(shopName);
                        projectIds[id_project].shopName = currentNames.join(
                            ", "
                        );
                    }
                } else {
                    projectIds[id_project] = {
                        designation: row.Project,
                        shopName: shopName,
                    };
                }
            } else {
                shopPublic.push(shopId);
            }
        }

        let savedData = {
            userId: userID,
            franchiseId: franchiseID,
            shopId: shopIds,
            operatorId: operatorID,
            uuidUser: uuidUser,
            projectIds,
        };
        if (shopPublic.length > 0) {
            toast.error(
                `${t(
                    "Attention, failure to dissociate one or more shops with a published template."
                )!}`,
                {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 2000,
                    theme: "colored",
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    icon: (
                        <ShieldExclamationIcon
                            width={25}
                            height={25}
                            fill="white"
                        />
                    ),
                }
            );
        }

        try {
            await fetch(apiUrl, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(savedData),
            })
                .then((response) => response.json())
                .then(async (result: any) => {
                    let error: boolean = result.error;
                    if (!error) {
                        setIsModalLoadingOpened(false);
                        toast.success(
                            `${t(
                                "The dissociation was successfully completed."
                            )!}`,
                            {
                                position: toast.POSITION.TOP_CENTER,
                                autoClose: 2000,
                                theme: "colored",
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                icon: (
                                    <CheckboxIcon
                                        height={25}
                                        width={25}
                                        fill="white"
                                    />
                                ),
                            }
                        );

                        setKey(Math.floor(Math.random() * 10000));
                    } else {
                        throw Error(result.message);
                    }
                });
        } catch (e: any) {
            setIsModalLoadingOpened(false);
            toast.error(`${t("There's an error")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                icon: true,
            });
        }
    }

    return (
        <ModalFooter className="border-top-0">
            <CustomSecondaryColorButton
                outline
                rounded
                variant="light"
                className="cmn_btn_cancelAlert"
                onClick={() => {
                    setIsModesModalDisassociate(false);
                }}
            >
                {t("Cancel")}
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                className="mr-2 cmn_btn_validateAlert"
                variant="primary"
                onClick={async () => {
                    setIsModalLoadingOpened(true);
                    setModalLoadingData({
                        title: "Disassociate in progress",
                        message:
                            "the disassociate of the template is in progress",
                    });
                    setIsModesModalDisassociate(false);
                    if (isClicked === false) {
                        await handleSaveButtonOnClickEvent();
                    }
                }}
            >
                {t("to confirm")}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
